module.exports = __webpack_public_path__ + "img/icon-delete-active.d03c30ad.svg";